import { graphql } from "@/graphql/codegen/gql"

graphql(`
  query GetDashboardTaskCounts($assignedToId: UUID) {
    dashboard {
      taskCounts(assignedToId: $assignedToId) {
        __typename
        ... on DashboardTaskCountsSuccess {
          priceApprovals
          qualityApprovals
          sourceChangeApprovals
          sampleRequests
        }
        ... on DashboardTaskCountsFailure {
          error {
            message
          }
        }
      }
    }
  }
`)

graphql(`
  query GetPriceApprovalList($input: GetPriceChangeHistoryInput!) {
    priceChange {
      getPriceChangeHistory(input: $input) {
        ... on GetPriceChangeHistorySuccess {
          priceChangeSubmissions {
            id
            changeId
            dateChanged
            reasonForUpdate
            productsAffectedCount
            customersAffectedCount
            submittedBy {
              name
            }
            assignedTo {
              name
            }
          }
        }
        ... on GetPriceChangeHistoryFailure {
          error {
            message
          }
        }
      }
    }
  }
`)

graphql(`
  query GetQualityApprovalList($input: QualityApprovalListInput!, $isAssignedToMe: Boolean!) {
    dashboard {
      myQualityApprovalList(input: $input) @include(if: $isAssignedToMe) {
        ...QualityApprovalListOutputFields
      }
      qualityApprovalList(input: $input) @skip(if: $isAssignedToMe) {
        ...QualityApprovalListOutputFields
      }
    }
  }
`)

graphql(`
  query GetQualityRequestList($input: MyRequestsListInput!) {
    dashboard {
      qualityRequestList(input: $input) {
        ...QualityApprovalListOutputFields
      }
    }
  }
`)

graphql(`
  query GetSourceChangeApprovalList($input: SourceChangeApprovalListInput!, $isAssignedToMe: Boolean!) {
    dashboard {
      mySourceChangeApprovalList(input: $input) @include(if: $isAssignedToMe) {
        ...SourceChangeApprovalListOutputFields
      }
      sourceChangeApprovalList(input: $input) @skip(if: $isAssignedToMe) {
        ...SourceChangeApprovalListOutputFields
      }
    }
  }
`)
